import { module } from 'modujs';
import { html } from '../utils/environment';
import LocomotiveScroll from 'locomotive-scroll';

export default class extends module {
    constructor(m) {
        super(m);

        // this.isSmooth = (this.getData('smooth') == 'true') || false
    }

    init() {
        this.scroll = new LocomotiveScroll({
            modularInstance: this,
            scrollCallback: this.onScrollBind,
        })

        // Force scroll to top
        if (history.scrollRestoration) {
            history.scrollRestoration = 'manual'
            window.scrollTo(0, 0)
        }

        this.scroll.lenisInstance.options.content.addEventListener('wheel', (event) => {
            const targets = event.composedPath();

            const stopPropagation = targets.some(target => target.id === 'cc-main');
            if (stopPropagation) {
                event.stopPropagation();
            }
        });
    }

    footerShow(args) {
        if (args.way === 'enter') {
            html.classList.add('has-footer-visible')
        }
        if (args.way === 'exit') {
            html.classList.remove('has-footer-visible')
        }
    }

    scrollTo(obj) {
        this.scroll?.scrollTo(obj.target, obj.options);
    }

    update() {
        //this.scroll?.update();
    }

    destroy() {
        super.destroy();
        this.scroll?.destroy();
    }
}
